import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ViewLayout, AdvanceStack } from './components';
import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

import { RibbonBar, RibbonDivider } from 'common/components';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import Addition from './components/sections/home-grid/AdditionSection';
import Categories from './components/sections/home-grid/Categories';
import Execute from './components/sections/home-grid/Execute';
import BackControl from './components/controls/home/Back';
import FilterPackageSection from './components/sections/product/FilterPackageSection';
import FilterProductSection from './components/sections/product/FilterProductSection';
import HistorySection from './components/sections/product/HistorySection';

import OpenProduct from './components/sections/product/OpenProduct';
import ProductGridAction from './components/sections/product/ProductGridAction';
import ShareSection from './components/sections/shared/ShareSection';
import AddProductToAPLModal from './components/modal/add-to-apl/AddProductToAPLModal';
import AddToNewAPLModal from './components/modal/add-to-apl/AddToNewAPLModal';

import gridViewSelectors from 'common/components/grid-view/controllers/selectors';
import * as ribbonSelectors from '@redux/ribbon/selectors';

// import * as selectorProduct from 'pages/branded-products/controllers/selectors';
import * as selectorsGlobal from '@redux/global/selectors';

import useCheckFavoriteRoute from 'hooks/useCheckFavoriteRoute';
import { useFilterGrid } from 'hooks/useFilterGrid';
import * as gridViewActions from 'common/components/grid-view/controllers/actions';

import { handleCreateSearchContainer } from 'pages/reporting/utils';

import userSelectors from '@redux/user/selectors';

import { isEmpty } from 'lodash';

const Products = () => {
  const dispatch = useDispatch();

  const selectedProducts = useSelector(
    gridViewSelectors.makeSelectDetailCurrentITemsSelection(),
  );
  const isDisplayProductNew = useSelector(
    selectorsGlobal.selectDisplayProductNew(),
  );

  const searchCategories = useSelector(
    userSelectors.makeSelectUserSearchCategories(),
  );

  const isFavoriteRoute = useCheckFavoriteRoute();

  const searchCategoriesEffected = useSelector(
    gridViewSelectors.makeSelectSearchCategoriesList(),
  );

  useEffect(() => {
    searchCategoriesEffected === null && // initial = null, if searchCategoriesEffected = null, make searchCategoriesEffected=[] in the first place
      dispatch(gridViewActions.setUserSearchCategoriesEffected([]));
  }, [searchCategories]);

  // const products = useSelector(selectorProduct.makeSelectProducts());

  const {
    productText,
    favProductText,
    productPrimaryFieldsOnly,
    favProductTextPrimaryFieldsOnly,
  } = useSelector(selectorsGlobal.selectSelectSearchText());

  const searchText = useMemo(() => {
    return {
      searchText: isFavoriteRoute ? favProductText : productText,
      primaryFieldsOnly: isFavoriteRoute
        ? favProductTextPrimaryFieldsOnly
        : productPrimaryFieldsOnly,
    };
  }, [
    isFavoriteRoute,
    favProductText,
    productText,
    favProductTextPrimaryFieldsOnly,
    productPrimaryFieldsOnly,
  ]);

  const filterProducts = useSelector(selectorsGlobal.selectFilterProducts());

  const { gridFilters } = useFilterGrid({
    entityType: 'product',
    clearOtherFilter: true,
  });

  const queryConditions = useSelector(
    window.location.pathname === '/products'
      ? gridViewSelectors.makeSelectProductsQuery()
      : gridViewSelectors.makeSelectFavProductsQuery(),
  );

  const closeDetailStack = useSelector(
    ribbonSelectors.selectCloseDetailStack(),
  );

  const paramsAddSearchProductToFolder = useSelector(
    selectorsGlobal.selectParamsAddSearchProductToFolder()
  );

  const disabledFilterSearch = useMemo(() => {
    if (
      isDisplayProductNew ||
      !isEmpty(paramsAddSearchProductToFolder?.advancedSearchContainer) ||
      !isEmpty(paramsAddSearchProductToFolder?.aplId) ||
      !isEmpty(paramsAddSearchProductToFolder?.filters) ||
      !isEmpty(paramsAddSearchProductToFolder?.filterFromAgGrid) ||
      !isEmpty(paramsAddSearchProductToFolder?.packageLevels) ||
      !isEmpty(paramsAddSearchProductToFolder?.search?.searchText) ||
      !isEmpty(paramsAddSearchProductToFolder?.searchCategory)
    ) {
      return false;
    }

    return true;
  }, [paramsAddSearchProductToFolder]);

  const isSelectAllSearchResult = useSelector(
    gridViewSelectors.makeSelectIsSelectAllSearchResult()
  );

  const someIsProductOverlay =
    selectedProducts?.length > 0 &&
    selectedProducts.some(
      (productItem) => productItem.isOverlayProduct === true,
    );

  const additionDisabled =
    disabledFilterSearch &&
    (selectedProducts?.length === 0 || someIsProductOverlay);

  const isDisabledCloseDetail =
    window.location.search !== '?query=1' ||
    closeDetailStack?.name !== 'query' ||
    closeDetailStack?.stack.length < 2;

  return (
    <>
      <RibbonBar>
        <ManageSharingSection />
        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT}>
          <DetailSection />
        </Can>
        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT}>
          <ViewLayout disabledGridQuery={isDisplayProductNew} />
        </Can>

        <RibbonDivider />
        <Addition
          type='product'
          selectedItemList={selectedProducts}
          isDisabled={additionDisabled}
          disabledFilterSearch={disabledFilterSearch}
          searchCategoriesEffected={searchCategoriesEffected}
          searchText={searchText}
          filterProducts={filterProducts}
          queryConditions={queryConditions}
          isFavoriteView={isFavoriteRoute}
        />
        <ShareSection selectedItemList={selectedProducts} />
        <RibbonDivider />
        {/* TODO: Add role permission later */}
        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT}>
          <OpenProduct />
        </Can>

        <RibbonDivider />
        <ProductGridAction isSelectAllSearchResult={isSelectAllSearchResult} />

        <RibbonDivider />
        {/* <FilterPackageSection />
        <Categories /> */}
        <FilterProductSection />
        {/* <RibbonDivider /> */}
        {/* <SubscriptionSection />
      <SyndicationSection /> */}
        {/* <RibbonDivider /> */}

        {/* TODO: Add role permission later */}
        {/* <Execute entityType='Product' /> */}
        <RibbonDivider />
        <HistorySection />

        {/* <PublicationSetup products={selectedProducts} />
      <GDSNPublication products={selectedProducts} /> */}
        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT}>
          <RibbonDivider />
          <AdvanceStack
            isNested
            selectedItemList={selectedProducts}
            disabledAdvanceFilter={isDisplayProductNew}
            // disabledAdvanceFilter={true}
          />
        </Can>
        <BackControl ribbonSide='right' isDisabled={isDisabledCloseDetail} />
      </RibbonBar>

      <AddProductToAPLModal selectedItemList={selectedProducts} />
      <AddToNewAPLModal selectedItemList={selectedProducts} />
    </>
  );
};

export default Products;
